import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/pix-web/pix-web/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Card = makeShortcode("Card");
const Button = makeShortcode("Button");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Card color="light-gray" name="quienes" img={`pix-faces.gif`} mdxType="Card">
  <h2 className="card-title">¿Quiénes pueden utilizar PiX?</h2>
  <p>
    PiX esta pensado para múltiples disciplinas, utilizando un lenguaje común e interpretativo para gráficar las interacciones de un objeto o servicio, actuando como facilitador en procesos creativos, de diseño o cocreación.
  </p>
    </Card>
    <Card color="orange" name="caracteristicas" img={`pix-card-caracteristicas.png`} mdxType="Card">
  <h2 className="card-title">Características</h2>
  <ol>
    <li>Inserta iconos mientras escribes con pix-iconName y TAB para saltar o crear la siguiente ranura.</li>
    <li>Tu trabajo queda guardado en el icono de perfil.</li>
    <li>Importa y exporta tu PiX en formato JSON o PNG.</li>
    <li>Salida PDF para crear excelentes entregables de diseño</li>
    <li>Recursos para trabajar plantillas de PiX en diferentes modalides, Miró, Toolkit, Adobe Illustrator.</li>
  </ol>
    </Card>
    <Card name="pixogramas" img={`pix-card-pixograma.png`} mdxType="Card">
  <h2 className={`card-title bold`}>Repositorio</h2>
  <p>Puedes revisar el repositorio Github en el siguiente botón.</p>
  <Button to="http://eadpucv.github.io/pixograms/" type="dark" size="lg" mdxType="Button">Ver pixogramas</Button>
    </Card>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      